module.exports = __webpack_public_path__ + "img/Dokumentation.6fafd9d4.svg";